module.exports = "https://coursera_assets.s3.amazonaws.com/images/03edc190811e10294fadf91a657408d7.png";